import { BrowserRouter, Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom'

import { AdminPage } from '@/admin/AdminPage'
import { ShadowDashboard } from '@/admin/ShadowDashboard'
import { ShadowComparison } from '@/admin/ShadowComparison'
import { LiveTestDashboard, RealChatReplayDashboard } from '@/admin/LiveTestDashboard'
import { LiveTestSelector, RealChatReplaySelector } from '@/admin/LiveTestSelector'
import { LiveTestComparison, RealChatReplayComparison } from '@/admin/LiveTestComparison'
import { AuthProvider } from '@/auth/AuthContext'
import { LoginPage } from '@/auth/LoginPage'
import { RequireAuth } from '@/auth/RequireAuth'
import { ChatPage } from '@/chat/ChatPage'

function ShadowComparisonRoute() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  if (!id) return <Navigate to="/admin/shadow" replace />
  return (
    <ShadowComparison
      convId={parseInt(id, 10)}
      onBack={() => navigate('/admin/shadow')}
    />
  )
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <ChatPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/shadow"
            element={
              <RequireAuth>
                <ShadowDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/shadow/:id"
            element={
              <RequireAuth>
                <ShadowComparisonRoute />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/live-test"
            element={
              <RequireAuth>
                <LiveTestDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/live-test/:id"
            element={
              <RequireAuth>
                <LiveTestSelector />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/live-test/:id/compare/:turnNum"
            element={
              <RequireAuth>
                <LiveTestComparison />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/real-chat-replay"
            element={
              <RequireAuth>
                <RealChatReplayDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/real-chat-replay/:id"
            element={
              <RequireAuth>
                <RealChatReplaySelector />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/real-chat-replay/:id/compare/:turnNum"
            element={
              <RequireAuth>
                <RealChatReplayComparison />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
